
<template>
  <div style="height: 300px;">
    <div class="dinwdw">
      <div class="name_boxr">微信授权账户：</div>
      <div style="display: flex;">
        <div><el-button
          type="primary"
          size="mini"
          @click="chooseoperatetwo"
        >选择</el-button></div>
        <div><el-button
          v-show="query.account_ids.length!==0"
          type="warning"
          size="mini"
          @click="query.account_ids = []"
        >清空</el-button></div>
        <div style="max-height: 200px; overflow-y: scroll;position: relative;">

          <el-tag
            v-for="itemrse, indexr in query.account_ids"
            :key="indexr"
            style="margin-right:10px;margin-bottom:5px"
            closable
            :type="'success'"
            @close="rightclicktwo(itemrse, indexr)"
          >
            {{ itemrse.account_name }}
          </el-tag>
        </div>

      </div>
    </div>
    <div class="dinwdw">
      <div class="name_boxr">分配的管理员：</div>
      <div>
        <el-button
          type="primary"
          size="mini"
          @click="chooseoperatetwoGroup"
        >选择</el-button>
        <el-tag
          v-if="query.admin_id"
          style="margin-right:10px;margin-bottom:5px"
          closable
          :type="'success'"
          @close="rightclicktwoGroup(admin.name)"
        >
          {{ admin.name }}
        </el-tag>
      </div>
    </div>
    <el-dialog
      title="微信授权账户id"
      :visible.sync="dialogAccountIds"
      width="50%"
      append-to-body
    >
      <accoutDetail
        ref="ids"
        @bandarr="bandarrtwo"
      />
    </el-dialog>
    <el-dialog
      title="分配的管理员id"
      :visible.sync="dialogAdmin_id"
      width="800px"
      append-to-body
    >
      <wechatAuthAccount
        ref="admin"
        @bandarr="bandarrtwoGroup"
      />
    </el-dialog>
    <div style="float: right;margin-top: 20px;">
      <el-button
        type="primary"
        size="mini"
        @click="submit"
      >确定</el-button>
    </div>
  </div>
</template>

<script>
import wechatAuthAccount from '../../WeChatAccount/components/wechatAuthAccount.vue'
import accoutDetail from '../../WeChatAccount/components/accoutDetail.vue'

export default {
  components: { wechatAuthAccount, accoutDetail },
  data() {
    return {
      dialogAccountIds: false,
      dialogAdmin_id: false,
      query: {
        account_ids: [],
        admin_id: ''
      },
      admin: {}
    }
  },
  created() {},
  mounted() {},
  methods: {
    submit() {
      if (this.query.account_ids.length === 0) {
        this.$message.info('请选择微信授权账户')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.query.admin_id == '') {
        this.$message.info('请选择分配的管理员')
        return
      }
      const obj = {
        account_ids: this.query.account_ids.map(v => v.account_id),
        admin_id: this.query.admin_id
      }
      this.$emit('callbackbacer', obj)
      this.query = {
        account_ids: [],
        admin_id: ''
      }
      this.admin = {}
    },
    sendr() {},
    bandarrtwo(arr) {
      this.dialogAccountIds = false
      console.log('arr', arr)
      this.query.account_ids = []
      this.query.account_ids = arr
    },
    rightclicktwo(item, indexr, index) {
      console.log(item, indexr)
      this.query.account_ids.splice(indexr, 1)
    },
    rightclicktwoGroup(item, indexr) {
      console.log(item, indexr)
      this.admin = {}
      this.query.admin_id = ''
    },
    chooseoperatetwo(index) {
      this.dialogAccountIds = true
      this.$nextTick(() => {
        this.$refs.ids.sendr(this.query.account_ids, 1)
      })
    },
    chooseoperatetwoGroup(index) {
      this.dialogAdmin_id = true
      this.$nextTick(() => {
        this.$refs.admin.sendr()
      })
    },
    bandarrtwoGroup(arr) {
      this.dialogAdmin_id = false
      const item = {
        name: arr.name,
        id: arr.id
      }
      this.query.admin_id = arr.id

      this.admin = {}
      this.admin = item
    }
  }
}
</script>

<style scoped>
/* @import url(); 引入css类 */
.dinwdw {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.name_boxr {
  color: rgb(169, 162, 151);
  font-size: 14px;
  width: 100px;
  text-align: right;
  flex-shrink: 0;
}
</style>
